// extracted by mini-css-extract-plugin
module.exports = {"card":"card--3yrX1","card_header":"card_header--30h2x","card_header_title":"card_header_title--3-Nol","content_column3":"content_column3--3YXJO"};